<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <b-row align-h="between" align-v="center">
              <h4 class="card-tittle">Reporte de Taller</h4>
<!--              <export-button :data="tableData" fileName="Reporte_Taller" />-->
              <b-button
                  class="spacingButton"
                  variant="danger"
                  @click="getAllReport()"
              >
                <template v-if="!isBusyButtonAll">Exportar</template>
                <b-spinner v-else small class="align-middle"></b-spinner>
              </b-button>
            </b-row>
            <filters
                :filtros="filtros"
                :value="filtersValue"
                @change="getAllReports"
                patentView="getPatentsOrdenByRut"
            />
            <b-table
              :items="tableData"
              :fields="fields"
              :current-page="currentPage"
              :busy="isBusy"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              show-empty
            >
              <!-- Inicio Spinner en estado "ocupado" de la tabla -->
              <template #table-busy>
                <div class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <!-- Fin Spinner en estado "ocupado" de la tabla -->

              <template #cell(descarga)="row">
                <div class="text-center">
                  <b-button
                    variant="danger"
                    class="btn-sm"
                    @click="downloadDocumento(row)"
                  >
                    <i
                      v-if="buttonClicked !== row.item.numeroOT"
                      class="bx bx-download font-size-16 align-middle"
                    />
                    <b-spinner v-else small class="align-middle"></b-spinner>
                  </b-button>
                </div>
              </template>

              <template #cell(fechaInicio)="row">
                {{ getDate(row.value) }}
              </template>
              <template #empty="">
                  <h5 style="text-align: center">
                  {{ $t("request.table.empty") }}
                  </h5>
              </template>

              <template #cell(fechaTermino)="row">
                {{ getDate(row.value) }}
              </template>

              <template #cell(km)="row">
                {{ getNumberWithSeparators(row.value) }}
              </template>
              <template #cell(gps)="row">
                {{ row.value ? "Si" : "No" }}
              </template>
              <template #cell(estado)="row">
                {{ getState(row.value) }}
              </template>
            </b-table>

            <!-- Inicio Paginación -->
            <div class="col">
              <div
                class="dataTables_paginate paging_simple_numbers float-right"
              >
                <ul class="pagination pagination-rounded mb-0">
                  <b-pagination
                    class="portal"
                    v-model="currentPage"
                    :per-page="perPage"
                    :total-rows="totRegistros"
                  ></b-pagination>
                </ul>
              </div>
            </div>
            <!-- Fin Paginación -->
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import tableConfig from "./tableConfig";
import { getDateWithFormat, thousandSeparator } from "@/utils";
import axios from "@/axios";
import DPConfig from "../../../components/dataPickerConf";
import moment from "moment";
import {b64toBlob} from "@/utils";
import Filter from "../../../components/filters/Filter";
import {toExcelThree} from "../../../utils";

export default {
  data() {
    return {
      sortBy: 'otNumero',
      sortDesc: true,
      lang: {
        formatLocale: DPConfig.formatLocale
      },
      tableData: [],
      fields: tableConfig.fields,
      filtros: ['rut', 'patent'],
      filtersValue: {
        rutEmpresa: "",
        patent: "",
        estado: ""
      },
      currentPage: 1,
      perPage: 10,
      totRegistros: 1,
      buttonClicked: false,
      isBusy: false,
      isBusyButtonAll: false,
      estados: ''
    };
  },
  components: {
    Layout,
    "filters": Filter
  },
  beforeMount() {
    this.getAllReports();
    axios.get("/EstadosOT").then(response => {
      this.estados = response.data;
    });
  },
  methods: {
    getDate(date) {
      return getDateWithFormat(date);
    },
    getNumberWithSeparators(number) {
      return thousandSeparator(number);
    },
    getAllReports() {
      if(this.filtersValue.rutEmpresa){
        this.isBusy = true;
        let path = "/GetOrdenes";
        let data;
        data = {
          rut: parseInt(this.filtersValue.rutEmpresa),
          patente: this.filtersValue.patent ? this.filtersValue.patent : "",
          fechaDesde: this.filtersValue.period[0] ? moment(this.filtersValue.period[0]).format('YYYY-MM-DD') : moment(new Date("2000-01-01")).format('YYYY-MM-DD'),
          fechaHasta: this.filtersValue.period[1] ? moment(this.filtersValue.period[1]).format('YYYY-MM-DD') : moment(new Date()).format('YYYY-MM-DD'),
          estado: this.filtersValue.estado ? this.filtersValue.estado : "",
          pagina: this.currentPage,
          registros: this.perPage
        }      
        axios
          .post(path, data)
          .then((reports) => {
            this.tableData = reports.data.datos;
            this.totRegistros = reports.data['totalRegistros'];
            this.isBusy = false;
          })
          .catch((error) => {
            if (error.response) {
              this.$bvToast.toast(this.$t('NoData.error.message').toString(), {
                title: this.$t('NoData.error.title').toString(),
                variant: 'danger',
                solid: true
              });
            }
            this.isBusy = false;
          });
      }      
    },
    getAllReport() {
      this.isBusyButtonAll = true;
      let dataAll;
      dataAll = {
        rut: parseInt(this.filtersValue.rutEmpresa),
        patente: this.filtersValue.patent ? this.filtersValue.patent : "",
        ffechaDesde: this.filtersValue.period[0] ? moment(this.filtersValue.period[0]).format('YYYY-MM-DD') : moment(new Date("2000-01-01")).format('YYYY-MM-DD'),
        fechaHasta: this.filtersValue.period[1] ? moment(this.filtersValue.period[1]).format('YYYY-MM-DD') : moment(new Date()).format('YYYY-MM-DD'),
        estado: this.filtersValue.estado ? this.filtersValue.estado : "",
        pagina: 1,
        registros: this.totRegistros,
      };
      axios
          .post("/GetOrdenes", dataAll)
          .then((Response) => {
            toExcelThree(Response.data.datos, "Reporte_Taller_");
            this.isBusyButtonAll = false;
          })
          .catch(() => {
            this.$bvToast.toast(this.$t("NoData.error.message").toString(), {
              title: this.$t("NoData.error.title").toString(),
              variant: "danger",
              solid: true,
            });
            this.isBusyButtonAll = false;
          });
    },
    downloadDocumento(row){
      this.isBusy = true;
      this.buttonClicked = row.item.numeroOT;
      axios.get(`/GetPdfOT/${this.buttonClicked}`)
          .then(documento => {
            if (documento.data.pdf) {
              const blob = b64toBlob(
                  documento.data.pdf,
                  "application/pdf"
              );
              let fileURL = window.URL.createObjectURL(blob);
              let fileLink = document.createElement("a");

              fileLink.href = fileURL;
              fileLink.setAttribute(
                  "download",
                  `OT_${row.item.numeroOT}.pdf`
              );
              document.body.appendChild(fileLink);

              fileLink.click();
              this.buttonClicked = undefined;
              this.isBusy = false;
            }else{
                this.$bvToast.toast(this.$t('lease.pdf.error.nonFound').toString(), {
                    title: this.$t('lease.pdf.error.download').toString(),
                    variant: 'danger',
                    solid: true
                });
              this.buttonClicked = undefined;
              this.isBusy = false;
            }
          })
          .catch(() => this.$bvToast.toast(this.$t('lease.pdf.error.nonFound').toString(), {
              title: this.$t('lease.pdf.error.download').toString(),
              variant: 'danger',
              solid: true
          }));
      this.isBusy = false;
    },
    getState(item) {
      for (let state of this.estados) {
        if (state.estado === item) {
          return state.descripcion
        }
      }
    }
      
  },
  watch:{
    currentPage(){
      this.getAllReports();
    }
  }
};
</script>

<style>
</style>